import { useTranslation } from "react-i18next";

export const useDateFnsFormatString = () => {
  const { i18n } = useTranslation();

  const formatMap: Record<string, string> = {
    cs: "dd. MM. yyyy",
    sk: "dd. MM. yyyy",
    en: "MM/dd/yyyy",
  };

  return formatMap[i18n.language] ?? formatMap.cs;
};
